import {t} from '@/core/utils/t'
import {documentComponent} from '@/core/utils/t/document-component'

export const doc = documentComponent({
  name: 'Colors',
  description: 'A list of all base colors available. Never use this directly in components. See ColorTheme component for usage.',
  categories: ['Colors', 'Styling'],
  props: t.object({}),
  todo: [
		'Add a way to open colors as a popup with keyboard shortcut while developing.'
  ],
})


